import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, unref as _unref, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-[20px] pr-[0px] bg-[#ededed]" }
const _hoisted_2 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_3 = { class: "lg:pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]" }
const _hoisted_4 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_5 = { class: "pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px] text-center" }
const _hoisted_6 = { class: "text-left text-2xl font-light my-[3%]" }

import offerNavigation from '@/components/SubNavigations/TheOfferNavigation.vue'
    import ContactsTable from '@/components/Contacts/ContactsTable.vue'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import router from '@/router'
    import useOfferStore from '@/utils/useOfferStore'
    import useContactStore from '@/utils/useContactStore'
    import { Offer } from '@/model/types'

    // Composable functions for offers and search
    
export default /*@__PURE__*/_defineComponent({
  __name: 'Offers',
  setup(__props) {

    const { offers, loading, fetchOffers, loadOffers, deleteOffers, searchTerm, search } =
        useOfferStore()
    const { duplicateContact } = useContactStore()

    // Fetch offers on component mount
    async function fetchDataOnMounted() {
        await fetchOffers()
    }

    fetchDataOnMounted()

    function selectContact(offer: Offer) {
        router.push('/offers/schoolview/' + offer.contactId)
    }

    //breadcrumbs
    const breadcrumbs = [
        {
            title: 'Offerten',
            disabled: false,
            href: 'offers',
        },
    ]

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(offerNavigation)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_breadcrumbs, { items: breadcrumbs }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(FullButton, {
          "data-cy": "newOfferButton",
          link: '/offers/selectcontacts/',
          width: "100",
          title: " Neue Offerte erstellen +",
          colour: "white"
        }),
        _createElementVNode("h2", _hoisted_6, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('offers.contactsWithOffers')), 1)
        ]),
        _createVNode(_component_v_card, {
          class: "w-full mx-auto",
          color: "grey-lighten-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  loading: _unref(loading),
                  density: "comfortable",
                  type: "input",
                  onInput: _cache[0] || (_cache[0] = ($event: any) => (_unref(search)())),
                  variant: "solo",
                  label: _ctx.$t('offers.pleaseSelectSchool'),
                  title: _ctx.$t('offers.enterSchool'),
                  autofocus: "",
                  modelValue: _unref(searchTerm),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(searchTerm) ? (searchTerm).value = $event : null)),
                  "append-inner-icon": "mdi-magnify",
                  "single-line": "",
                  "hide-details": "",
                  "data-cy": "offer-search"
                }, null, 8, ["loading", "label", "title", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(ContactsTable, {
          load: _unref(loadOffers),
          hasActions: true,
          deleteMethod: _unref(deleteOffers),
          contacts: _unref(offers),
          selectMethod: selectContact,
          duplicateMethod: _unref(duplicateContact),
          contactsCount: 50
        }, null, 8, ["load", "deleteMethod", "contacts", "duplicateMethod"])
      ])
    ])
  ]))
}
}

})